import { useContent } from '@wix/funnel-builder-lizard'
import React, { FC, useMemo } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'
import { DesignSystemTokensLoader } from '../../reusable/DesignSystemTokensLoader'
import { WixMobileCategory as WixMobileCategoryUnwrapped } from './WixMobileCategory'
import { TWixMobileCategory } from './WixMobileCategory.content'
import { WixMobileCategoryNoSuggestions } from './WixMobileCategoryNoSuggestions/WixMobileCategoryNoSuggestions'

export const WixMobileCategory: FC = () => {
  const { content } = useContent<TWixMobileCategory>()
  const businessTermService = useMemo(() => new BusinessTermService(ambassadorHttpClient), [])

  const variant =
    content.inputType === 'text' ? (
      <WixMobileCategoryNoSuggestions />
    ) : (
      <WixMobileCategoryUnwrapped businessTermService={businessTermService} />
    )

  return <DesignSystemTokensLoader type="odeditor">{variant}</DesignSystemTokensLoader>
}
